import React, { useContext } from 'react';

import LocaleContext from 'contexts/locale-context';

import Spacer from 'components/spacer';
import AnchorButton from 'components/anchor-button';

const Error = ({ title, subtitle, image }) => {
  const { locale, translations } = useContext(LocaleContext);
  const commonTranslations = translations.common;

  return (
    <div className='error-container'>
      {image && <img alt='gif' src={image}/>}
      <Spacer size='xxxxl' />
      <h1>{title}</h1>
      <p>{subtitle}</p>
      <Spacer size='xxxxl' />
      <AnchorButton href={`/${locale}`}>{commonTranslations.send_new_transfer}</AnchorButton>
    </div>
  );
};

export default Error;